import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Zap, Scale, Users, Shield, Globe, TrendingUp } from 'lucide-react';

export const WhyBuildSection = () => {
  const { t } = useLanguage();

  const features = [
    { icon: Zap, key: 'lowCost', color: 'text-[#ffd166]' },
    { icon: Scale, key: 'scalability', color: 'text-primary' },
    { icon: Users, key: 'accountAbstraction', color: 'text-[#a3a3ff]' },
    { icon: Shield, key: 'governance', color: 'text-primary' },
    { icon: Globe, key: 'realWorld', color: 'text-[#a3a3ff]' },
    { icon: TrendingUp, key: 'community', color: 'text-[#ffd166]' },
  ];

  return (
    <section className="relative py-20 md:py-32 overflow-hidden">
      {/* Background */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-15"
        style={{ 
          backgroundImage: `url('https://images.unsplash.com/photo-1664526937033-fe2c11f1be25?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxmdXR1cmlzdGljJTIwZGlnaXRhbCUyMGluZnJhc3RydWN0dXJlJTIwbmV0d29yayUyMG5vZGVzJTIwYmx1ZXxlbnwwfHx8fDE3NzExMzAxNjV8MA&ixlib=rb-4.1.0&q=85')` 
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#000000] via-transparent to-[#000000]" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-testid="why-build-headline">
            {t('whyBuild.headline')}
          </h2>
          <p className="text-lg text-slate-300 max-w-2xl mx-auto">
            {t('whyBuild.intro')}
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={feature.key}
                className={`glass-card rounded-xl p-6 dapp-card animate-fade-in stagger-${index + 1}`}
                data-testid={`feature-${feature.key}`}
              >
                <div className={`feature-icon mb-4 ${feature.color}`}>
                  <Icon className={`w-6 h-6 ${feature.color}`} />
                </div>
                <h3 className="text-lg font-semibold text-white mb-2">
                  {t(`whyBuild.features.${feature.key}.title`)}
                </h3>
                <p className="text-sm text-slate-400 leading-relaxed">
                  {t(`whyBuild.features.${feature.key}.desc`)}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
